import { defaultBarChartOptions } from './constants';

export const buildAdditionalCss = (data: any[] = []) => (data?.[0]?.data || []).reduce(
    (acc, { color }, idx) => ({ ...acc, [`--bar-chart-color-${idx}`]: color }), {},
);

export const getBarChartOptions = (
    max: number, data: any[], labels: string[], height: number, labelFormat: (value: string, point: any) => string, barHeight: number,
) => {
    const baseLength = 15;
    const baseBarHeight = barHeight || 80;
    const baseCategoryLineHeight = 44;

    return {
        ...defaultBarChartOptions,
        chart: {
            ...defaultBarChartOptions.chart,
            height,
            events: {
                render(this: any) {
                    const { categories } = this.xAxis[0];
                    const maxLines = Math.max(...categories
                        .map((item) => Math.ceil(item.length / baseLength)) || 1);

                    const plotHeight = categories.length * baseBarHeight
                        + baseCategoryLineHeight * maxLines;
                    const chartHeight = plotHeight + (this.chartHeight - this.plotHeight);

                    if (!height && chartHeight !== this.chartHeight) {
                        this.setSize(null, chartHeight, false);
                    }
                },
            },
        },
        xAxis: {
            ...defaultBarChartOptions.xAxis,
            categories: labels,
            labels: {
                ...defaultBarChartOptions.xAxis.labels,
                formatter(this: any) {
                    const { pos, value } = this;
                    return `<div class="bar-chart__label">${labelFormat(value, data[0].data[pos])}</div>`;
                },
            },
        },
        yAxis: {
            ...defaultBarChartOptions.yAxis,
            endOnTick: false,
            max,
        },
        series: [...data],
        lang: {
            sanitize: function (html: string) {
                return html.replace(
                    /\b(href|src)=["']?(javascript|data|vbscript):/gi,
                    '$1="#"'
                );
            }
        }
    };
};
